
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./config/ember-intl.js"
import * as amdModule1 from "./config/environment.ts"
import * as amdModule2 from "./formats.js"
import * as amdModule3 from "./router.js"
import * as amdModule4 from "./services/common-storage.js"
import * as amdModule5 from "./services/ember-sortable-internal-state.js"
import * as amdModule6 from "./services/page-title.js"
import * as amdModule7 from "./services/intl.js"
import * as amdModule8 from "./services/file-queue.js"
import * as amdModule9 from "./initializers/coordinator-setup.js"
import * as amdModule10 from "./services/drag-coordinator.js"
import * as amdModule11 from "./templates/application.hbs"
import * as amdModule12 from "./routes/application.js"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"mish-client/config/ember-intl": amdModule0,
"mish-client/config/environment": amdModule1,
"mish-client/formats": amdModule2,
"mish-client/router": amdModule3,
"mish-client/services/common-storage": amdModule4,
"mish-client/services/ember-sortable-internal-state": amdModule5,
"mish-client/services/page-title": amdModule6,
"mish-client/services/intl": amdModule7,
"mish-client/services/file-queue": amdModule8,
"mish-client/initializers/coordinator-setup": amdModule9,
"mish-client/services/drag-coordinator": amdModule10,
"mish-client/templates/application": amdModule11,
"mish-client/routes/application": amdModule12,
  },
  exportFastbootModules
);
